export default {
  MALE: 'male',
  FEMALE: 'female',
  UNKNOWN: 'UNKNOWN'
}
